import { BASE_API_CONFIG } from "../../util/Api";
import { NETWORK_METHOD } from "../../util/ApiHelper";

export const MY_EXIM_API_POINTS = {
    getUpdatedPoints: (uuid) => ({
        method: NETWORK_METHOD.GET,
        url: `${BASE_API_CONFIG.baseURL}/points/${uuid}`
    }),
};